import React from 'react';

import { Badge, Container, Description, Points } from './styles';

import { API_S3 } from '../../services/api_s3';
import { useTheme } from '../../hooks/theme';

interface ICardAchiviementProps {
  badge_icon: string;
  status: 'pending' | 'concluded';
  title: string;
  description: string;
  exp_total_value: number | string;
  is_hidden: boolean;
}

const CardAchiviement: React.FC<ICardAchiviementProps> = ({ badge_icon, status, title, description, exp_total_value }) => {
  const { theme } = useTheme();

  return (
    <Container photo={badge_icon} status={status}>
      <header>
        <main>
         <img src={badge_icon} alt={title} loading='lazy' />
        </main>
      </header>
      <main>
        <div>
          <h2>{title}</h2>
        </div>
        <Description>
          {description}
        </Description>
        <Points>
          <strong>{exp_total_value}</strong> Exp
        </Points>
        <footer>
          <p>
            <span style={status === 'concluded' ? { background: theme === 'light' ? '#f8f8f8' : '#162036'} : { }}>
              {status === 'concluded' ? 'Conquista desbloqueada' : 'Conquista bloqueada'}
            </span>
          </p>
        </footer>
        <img src={badge_icon} alt={title} loading='lazy' />
      </main>
    </Container>
  );
}

export default CardAchiviement;